import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectModalInputData, SelectModalItem, SelectModalOutput } from 'models';
import { BtnComponent } from '../btn/btn.component';
import { CommonModule } from '@angular/common';



@Component({
  selector: 'app-select-modal',
  templateUrl: './select-modal.component.html',
  standalone: true,
  imports: [CommonModule, BtnComponent],
  styleUrl: './select-modal.component.css'
})
export class SelectModalComponent {
  
  ITEM_ID_PREFIX = 'Selection_Modal_Item_';
  header: string;
  subHeader: string;
  selectionItems: SelectModalItem[];
  isMultipleSelection: boolean = true;
  emptyMsg: string = 'Nessun elemento trovato';
  isShowDeleteButton: boolean = false;
  itemsToDelete: SelectModalItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: SelectModalInputData,
    private dialogRef: MatDialogRef<SelectModalComponent>,
  ) {
    this.header = data?.header ?? '';
    this.subHeader = data?.subHeader;
    this.selectionItems = data?.selectItems ?? [];
    this.isMultipleSelection = data?.isMultipleSelection ?? true;
    this.emptyMsg = data?.emptyMsg ?? 'Nessun elemento trovato';
    this.isShowDeleteButton = data?.isShowDeleteButton ?? false;
  }

  itemClicked(item: SelectModalItem) {
    if (this.data.isMultipleSelection) {
      item.isSelected = !item.isSelected;
  
      if(!this.data.isMultipleSelection) {
        this.selectionItems.forEach(x => {
          if(x.id != item.id) {
            x.isSelected = false;
          }
        })
      }
    }
    else {
      this.closeDialog([item.value]);
    }
  }
  
  deleteItem(item: SelectModalItem) {
    this.itemsToDelete.push(item);
  }

  deleteItems() {
    const output: SelectModalOutput = {
      isDelete: true,
      items: this.itemsToDelete
    };
    this.closeDialog(output);
  }

  isItemHidden(item: SelectModalItem): boolean {
    return this.itemsToDelete.findIndex(x => x.id == item.id) > -1
  }

  getSelectedItems(): string[] {
    return this.data?.selectItems.filter(item => item.isSelected).map(item => item.value) ?? []
  }

  closeDialog(data: (string[] | SelectModalOutput | null)) {
    this.dialogRef.close(data);
  }

}
